// src/guides/openGuide.js
// Open a Host Playbook guide from anywhere (mission rows, Quick Action ?,
// Playbook cards). Same window-event pattern as openWelcomeTour — the event
// name lives in exactly this one file; the single GuideViewerHost mounted in
// the dashboard layout listens and renders. Unknown/hidden guide ids no-op
// at the listener (fail closed).

const GUIDE_EVENT = 'astra:guideOpen';

export function openGuide(guideId, { skin = 'light' } = {}) {
  window.dispatchEvent(new CustomEvent(GUIDE_EVENT, { detail: { guideId, skin } }));
}

export function onGuideOpen(handler) {
  const listener = (e) => handler(e?.detail || {});
  window.addEventListener(GUIDE_EVENT, listener);
  return () => window.removeEventListener(GUIDE_EVENT, listener);
}

// Per-user per-guide seen markers (device-local, same model as the
// welcome-tour/celebration seen-sets). Used for Playbook read ticks and NEW
// chips only — never for gating.
const seenKey = (userDocId, guideId) => `guideSeen_v1_${userDocId}_${guideId}`;
const SEEN_EVENT = 'astra:guideSeenChanged';

export function markGuideSeen(userDocId, guideId) {
  if (!userDocId || !guideId) return;
  try {
    localStorage.setItem(seenKey(userDocId, guideId), new Date().toISOString());
  } catch {
    /* storage unavailable — ticks just won't persist */
  }
  // Lets the Playbook page flip its read-ticks live after the viewer closes.
  window.dispatchEvent(new CustomEvent(SEEN_EVENT));
}

export function onGuideSeenChanged(handler) {
  window.addEventListener(SEEN_EVENT, handler);
  return () => window.removeEventListener(SEEN_EVENT, handler);
}

export function isGuideSeen(userDocId, guideId) {
  if (!userDocId || !guideId) return false;
  try {
    return Boolean(localStorage.getItem(seenKey(userDocId, guideId)));
  } catch {
    return false;
  }
}
